import { Heading } from 'src/components/Heading';
import { ContentWrapper } from 'src/components/ContentWrapper';
import { Chat } from './components/Chat';
import { useNavigation } from 'src/contexts/NavigationContext';
import { Button } from 'src/components/Button';
import { Can, Subject } from 'src/hooks/usePermissions';
import { ChatAgentProvider, useChatAgent } from './contexts/ChatAgentContext';

const ChatAgentContent = () => {
  const { navigateWithBlocking } = useNavigation();
  const { agent, agentLoading, saveAgent, isValidAgent } = useChatAgent();

  const saveAndExit = async () => {
    await saveAgent(agent);
    navigateWithBlocking('/agents');
  };

  return (
    <div className="flex-1">
      <Heading
        title="Chat Agent"
        subtitle="Use our bot to create your own agent"
      >
        <div className="flex gap-2 mt-3">
          <Button
            variant="outlined"
            size="small"
            onClick={() => navigateWithBlocking('/agents')}
          >
            Cancel
          </Button>

          <Can operation="update" subject={Subject.AGENTS}>
            <Button
              variant="outlined"
              size="small"
              onClick={saveAndExit}
              disabled={!isValidAgent() || agentLoading}
            >
              Save & Exit
            </Button>
          </Can>

          <Can operation="update" subject={Subject.AGENTS}>
            <Button
              size="small"
              onClick={() => saveAgent(agent)}
              disabled={!isValidAgent() || agentLoading}
            >
              {agentLoading ? 'Loading...' : 'Save'}
            </Button>
          </Can>
        </div>
      </Heading>

      <ContentWrapper>
        <Chat />
      </ContentWrapper>
    </div>
  );
};

export const ChatAgent = () => {
  return (
    <ChatAgentProvider>
      <ChatAgentContent />
    </ChatAgentProvider>
  );
};
